import React from 'react'
import PublicLayout from '@/pages/PublicLayout';
import NavigationBar from '@/components/pages/Landing/components/NavigationBar';
import { MODE_DARK, MODE_LIGHT } from '@/constants/theme.constant';
import HeroContent from '@/components/pages/Landing/components/HeroContent';
import Features from '@/components/pages/Landing/components/Features';
import Demos from '@/components/pages/Landing/components/Demos';
import TechStack from '@/components/pages/Landing/components/TechStack';
import EarlyAccess from '@/components/pages/Landing/components/EarlyAccess';
import OtherFeatures from '@/components/pages/Landing/components/OtherFeatures';
import Components from '@/components/pages/Landing/components/Components';
import LandingFooter from '@/components/pages/Landing/components/LandingFooter';
import useDarkMode from '@/utils/hooks/useDarkMode';
import { useThemeStore } from '@/store/themeStore';
import { Head } from '@inertiajs/react';

const Home = () => {
  const [isDark, setMode] = useDarkMode()

  const mode = isDark ? MODE_DARK : MODE_LIGHT

  const schema = useThemeStore((state) => state.themeSchema)
  const setSchema = useThemeStore((state) => state.setSchema)

  const toggleMode = () => {
    setMode(mode === MODE_LIGHT ? MODE_DARK : MODE_LIGHT)
  }

  return (
    <main className="px-4 lg:px-0 text-base">
      <Head>
        <title>Private & Encrypted Note Management</title>
        <meta name="description" content="MemoSlate is a secure and private note management application that encrypts your notes. Experience peace of mind with end-to-end encryption and robust features designed for privacy-conscious users." />
      </Head>

      <NavigationBar toggleMode={toggleMode} mode={mode} />
      <div className="relative">
        <div
          style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='50' height='50' fill='none' stroke='${mode === MODE_LIGHT ? 'rgb(0 0 0 / 0.04)' : 'rgb(255 255 255 / 0.04)'}'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`,
          }}
          className="absolute inset-0 [mask-image:linear-gradient(to_bottom,white_5%,transparent_70%)] pointer-events-none select-none"
        ></div>
        <HeroContent mode={mode} />
      </div>
      {/*<Features*/}
      {/*  mode={mode}*/}
      {/*  schema={schema}*/}
      {/*  setSchema={setSchema}*/}
      {/*  onModeChange={(value) => setMode(value ? 'dark' : 'light')}*/}
      {/*/>*/}
      {/*<Demos mode={mode} />*/}
      {/*<TechStack />*/}
      <EarlyAccess />
      <OtherFeatures />
      {/*<Components />*/}
      <LandingFooter mode={mode} />
    </main>
  );
}

Home.layout = (page: React.ReactNode) => <PublicLayout children={page} />;
export default Home;
